import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import SideBar from '../admincomponents/SideBar';
import TopNavBar from '../admincomponents/TopNavBar';
import Footer from '../admincomponents/Footer';
const apiUrl = process.env.REACT_APP_API_URL;
function AdminStudentAllocation() {
  const [allocations, setAllocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [courses, setCourses] = useState([]);
  const [batches, setBatches] = useState([]);
  const [allStudents, setAllStudents] = useState([]);
  const [assignForm, setAssignForm] = useState({ studentId: '', courseId: '', batchId: '' });
  const [assignModalOpen, setAssignModalOpen] = useState(false);
  const [assignError, setAssignError] = useState('');
  const [assignSuccess, setAssignSuccess] = useState('');
  const [search, setSearch] = useState('');
  const [courseFilter, setCourseFilter] = useState('');
  const [removingId, setRemovingId] = useState(null);
  const fetchAllocations = async () => {
    setLoading(true);
    setError('');
    try {
      const sessionData = JSON.parse(sessionStorage.getItem('adminSession'));
      if (!sessionData || !sessionData.token) {
        setError('You must be logged in to view allocations.');
        setLoading(false);
        return;
      }
      const response = await axios.get(`${apiUrl}/api/admin/student-allocations?nocache=${Date.now()}`, {
        headers: {
          Authorization: `Bearer ${sessionData.token}`
        }
      });
      if (response.data.success) {
        setAllocations(response.data.allocations);
      } else {
        setError(response.data.message || 'Failed to fetch allocations.');
      }
    } catch (err) {
      console.error('Error fetching allocations:', err);
      setError(err.response?.data?.message || 'Error fetching allocations. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchAllocations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const sessionData = JSON.parse(sessionStorage.getItem('adminSession'));
        if (!sessionData || !sessionData.token) return;
        const response = await axios.get(`${apiUrl}/api/admin/courses?nocache=${Date.now()}`, {
          headers: { Authorization: `Bearer ${sessionData.token}` }
        });
        if (response.data.success) {
          setCourses(response.data.courses);
        }
      } catch (err) {
        console.error('Error fetching courses:', err);
      }
    };
    fetchCourses();
  }, []);
  useEffect(() => {
    const fetchAllStudents = async () => {
      try {
        const sessionData = JSON.parse(sessionStorage.getItem('adminSession'));
        if (!sessionData || !sessionData.token) return;
        const response = await axios.get(`${apiUrl}/api/admin/students?nocache=${Date.now()}`, {
          headers: { Authorization: `Bearer ${sessionData.token}` }
        });
        if (response.data.success) {
          setAllStudents(response.data.students);
        }
      } catch (err) {
        console.error('Error fetching students:', err);
      }
    };
    fetchAllStudents();
  }, []);
  useEffect(() => {
    if (assignForm.courseId) {
      const fetchBatches = async () => {
        try {
          const sessionData = JSON.parse(sessionStorage.getItem('adminSession'));
          if (!sessionData || !sessionData.token) return;
          const response = await axios.get(`${apiUrl}/api/admin/batches/${assignForm.courseId}?nocache=${Date.now()}`, {
            headers: { Authorization: `Bearer ${sessionData.token}` }
          });
          if (response.data.success) {
            setBatches(response.data.batches);
          }
        } catch (err) {
          console.error('Error fetching batches:', err);
        }
      };
      fetchBatches();
    } else {
      setBatches([]);
    }
  }, [assignForm.courseId]);
  const handleAssignChange = (e) => {
    const { id, value } = e.target;
    setAssignForm((prev) => ({ ...prev, [id]: value }));
    setAssignError('');
  };
  const openAssignModal = (studentId) => {
    setAssignForm({ studentId, courseId: '', batchId: '' });
    setAssignModalOpen(true);
    setAssignError('');
    setAssignSuccess('');
  };
  const closeAssignModal = () => {
    setAssignModalOpen(false);
  };
  const handleRemove = async (allocation) => {
    const name = `${allocation.firstName} ${allocation.lastName}`.trim();
    if (!window.confirm(`Remove "${allocation.courseName}" from ${name}?`)) return;
    setRemovingId(allocation.id);
    setError('');
    try {
      const sessionData = JSON.parse(sessionStorage.getItem('adminSession'));
      if (!sessionData || !sessionData.token) return;
      const response = await axios.delete(`${apiUrl}/api/admin/student-allocations/${allocation.id}`, {
        headers: { Authorization: `Bearer ${sessionData.token}` }
      });
      if (response.data.success) {
        setAllocations((prev) => prev.filter((a) => a.id !== allocation.id));
      } else {
        setError(response.data.message || 'Failed to remove course.');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Error removing course.');
    } finally {
      setRemovingId(null);
    }
  };

  const filteredAllocations = allocations.filter((allocation) => {
    if (courseFilter && String(allocation.courseid) !== courseFilter) return false;
    if (search) {
      const q = search.trim().toLowerCase();
      const haystack = [allocation.firstName, allocation.lastName, allocation.student_id]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();
      if (!haystack.includes(q)) return false;
    }
    return true;
  });

  const handleAssignSubmit = async (e) => {
    e.preventDefault();
    if (!assignForm.studentId || !assignForm.courseId || !assignForm.batchId) {
      setAssignError('Please select a student, course, and batch.');
      return;
    }
    try {
      const sessionData = JSON.parse(sessionStorage.getItem('adminSession'));
      if (!sessionData || !sessionData.token) return;
      const response = await axios.post(`${apiUrl}/api/admin/student-allocations`, {
        studentId: assignForm.studentId,
        courseId: assignForm.courseId,
        batchId: assignForm.batchId
      }, {
        headers: { Authorization: `Bearer ${sessionData.token}` }
      });
      if (response.data.success) {
        setAssignSuccess('Course and batch assigned successfully.');
        await fetchAllocations();
        setTimeout(() => {
          closeAssignModal();
        }, 1200);
      } else {
        setAssignError(response.data.message || 'Failed to assign course and batch');
      }
    } catch (err) {
      setAssignError(err.response?.data?.message || 'Error assigning course and batch');
    }
  };
  return (
    <>
      <SideBar />
      <div className="dashboard-main-wrapper">
        <TopNavBar />
        <div className="dashboard-body">
          <div className="breadcrumb-with-buttons mb-24 flex-between flex-wrap gap-8">
            <div className="breadcrumb mb-24">
              <ul className="flex-align gap-4">
                <li>
                  <Link to="/admin-dashboard" className="text-gray-200 fw-normal text-15 hover-text-main-600">
                    Home
                  </Link>
                </li>
                <li>
                  <span className="text-gray-500 fw-normal d-flex">
                    <i className="ph ph-caret-right" />
                  </span>
                </li>
                <li>
                  <span className="text-main-600 fw-normal text-15">Student Course Allocations</span>
                </li>
              </ul>
            </div>
            <button
              type="button"
              onClick={() => openAssignModal('')}
              className="btn btn-main rounded-pill py-9 px-24"
            >
              + Assign Course
            </button>
          </div>
          <div className="card mb-24">
            <div className="card-body">
              <div className="row g-16">
                <div className="col-md-6">
                  <label className="text-13 text-gray-500 mb-4 d-block">Search</label>
                  <input
                    type="text"
                    className="form-control py-9"
                    placeholder="Search student name or student ID..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
                <div className="col-md-6">
                  <label className="text-13 text-gray-500 mb-4 d-block">Course</label>
                  <select className="form-control py-9" value={courseFilter} onChange={(e) => setCourseFilter(e.target.value)}>
                    <option value="">All Courses</option>
                    {courses.map((c) => (
                      <option key={c.id} value={c.id}>{c.coursename}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="card overflow-hidden">
            <div className="card-body p-0 overflow-x-auto">
              {loading && (
                <div className="alert alert-info mb-0" role="alert">
                  Loading allocations...
                </div>
              )}
              {error && (
                <div className="alert alert-danger mb-0" role="alert">
                  {error}
                </div>
              )}
              {!loading && !error && allocations.length === 0 && (
                <div className="alert alert-warning mb-0" role="alert">
                  No allocations found.
                </div>
              )}
              {!loading && !error && allocations.length > 0 && filteredAllocations.length === 0 && (
                <div className="alert alert-warning mb-0" role="alert">
                  No allocations match your search/filters.
                </div>
              )}
              {!loading && !error && filteredAllocations.length > 0 && (
                <table id="allocationTable" className="table table-striped">
                  <thead>
                    <tr>
                      <th className="fixed-width">
                        <div className="form-check">
                          <input
                            className="form-check-input border-gray-200 rounded-4"
                            type="checkbox"
                            id="selectAll"
                          />
                        </div>
                      </th>
                      <th className="h6 text-gray-300">Student Name</th>
                      <th className="h6 text-gray-300">Student ID</th>
                      <th className="h6 text-gray-300">Course</th>
                      <th className="h6 text-gray-300">Batch</th>
                      <th className="h6 text-gray-300">Date Assigned</th>
                      <th className="h6 text-gray-300">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredAllocations.map((allocation) => (
                      <tr key={allocation.id}>
                        <td className="fixed-width">
                          <div className="form-check">
                            <input
                              className="form-check-input border-gray-200 rounded-4"
                              type="checkbox"
                            />
                          </div>
                        </td>
                        <td>
                          <span className="h6 mb-0 fw-medium text-gray-300">
                            {allocation.firstName} {allocation.lastName}
                          </span>
                        </td>
                        <td>
                          <span className="h6 mb-0 fw-medium text-gray-300">
                            {allocation.student_id || 'N/A'}
                          </span>
                        </td>
                        <td>
                          <span className="h6 mb-0 fw-medium text-gray-300">
                            {allocation.courseName.length > 30 ? `${allocation.courseName.substring(0, 30)}...` : allocation.courseName || 'Not Assigned'}
                          </span>
                        </td>
                        <td>
                          <span className="h6 mb-0 fw-medium text-gray-300">
                            {allocation.batchName.length > 30 ? `${allocation.batchName.substring(0, 30)}...` : allocation.batchName || 'Not Assigned'}
                          </span>
                        </td>
                        <td>
                          <span className="h6 mb-0 fw-medium text-gray-300">
                            {new Date(allocation.dateassigned).toLocaleDateString()}
                          </span>
                        </td>
                        <td>
                          <Link
                            to={`/admin-edit-student/${allocation.sp_id}`}
                            className="bg-main-50 text-main-600 py-2 px-14 rounded-pill hover-bg-main-600 hover-text-white"
                          >
                            Edit Student
                          </Link>
                          <button
                            onClick={() => openAssignModal(allocation.sp_id)}
                            className="bg-warning-50 text-warning-600 py-2 px-14 rounded-pill hover-bg-warning-600 hover-text-white ml-2"
                          >
                            Add Course
                          </button>
                          <button
                            onClick={() => handleRemove(allocation)}
                            disabled={removingId === allocation.id}
                            style={{ backgroundColor: '#dc3545', borderColor: '#dc3545', color: '#fff', opacity: removingId === allocation.id ? 0.6 : 1 }}
                            className="py-2 px-14 rounded-pill ml-2 border-0"
                          >
                            {removingId === allocation.id ? 'Removing...' : 'Remove'}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
            <div className="card-footer flex-between flex-wrap">
              <span className="text-gray-900">
                Showing {filteredAllocations.length} of {allocations.length} entries
              </span>
              <ul className="pagination flex-align flex-wrap">
                <li className="page-item active">
                  <a
                    className="page-link h-44 w-44 flex-center text-15 rounded-8 fw-medium"
                    href="#"
                  >
                    1
                  </a>
                </li>
              </ul>
            </div>
          </div>
          {/* Assign New Course Modal */}
          {assignModalOpen && (
            <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
  <div className="modal-dialog">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title">Assign New Course and Batch</h5>
        <button type="button" className="btn-close" onClick={closeAssignModal}></button>
      </div>
      <div className="modal-body">
        {assignError && <div className="alert alert-danger">{assignError}</div>}
        {assignSuccess && <div className="alert alert-success">{assignSuccess}</div>}
        <form onSubmit={handleAssignSubmit}>
          <div className="mb-3">
            <label htmlFor="studentId" className="form-label">Student</label>
            <select
              id="studentId"
              className="form-select"
              value={assignForm.studentId}
              onChange={handleAssignChange}
              required
            >
              <option value="" disabled>Select a student</option>
              {allStudents.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.firstName} {s.lastName}{s.studentid ? ` (${s.studentid})` : ''}
                </option>
              ))}
            </select>
          </div>
          <div className="mb-3">
            <label htmlFor="courseId" className="form-label">Course</label>
            <select
              id="courseId"
              className="form-select"
              value={assignForm.courseId}
              onChange={handleAssignChange}
              required
            >
              <option value="" disabled>Select a course</option>
              {courses.map((course) => (
                <option key={course.id} value={course.id}>
                  {course.coursename}
                </option>
              ))}
            </select>
          </div>
          <div className="mb-3">
            <label htmlFor="batchId" className="form-label">Batch</label>
            <select
              id="batchId"
              className="form-select"
              value={assignForm.batchId}
              onChange={handleAssignChange}
              required
            >
              <option value="" disabled>Select a batch</option>
              {batches.map((batch) => (
                <option key={batch.id} value={batch.id}>
                  {batch.batchname}
                </option>
              ))}
            </select>
          </div>
          <button type="submit" className="btn btn-primary">Assign</button>
          <button type="button" className="btn btn-secondary ms-2" onClick={closeAssignModal}>Close</button>
        </form>
      </div>
    </div>
  </div>
</div>
          )}
        </div>
        <Footer />
      </div>
    </>
  );
}
export default AdminStudentAllocation;